<template>
  <div>
    <div style="margin-bottom:10px;">
      <el-radio-group v-model="itemsType" size="small">
        <el-radio-button label="0">Offer Items</el-radio-button>
        <el-radio-button label="1">Require Items</el-radio-button>
        <el-radio-button label="2">PO Items</el-radio-button>
        <el-radio-button label="3">Invoice Items</el-radio-button>
      </el-radio-group>
    </div>
    <div style="font-size:14px;font-weight:bold;">show
      <el-select v-model="itemsPageSize" style="width:120px;" @change="fetchItemsList">
        <el-option label="30 pcs" :value="30"></el-option>
        <el-option label="40 pcs" :value="40"></el-option>
        <el-option label="60 pcs" :value="60"></el-option>
        <el-option label="80 pcs" :value="80"></el-option>
        <el-option label="100 pcs" :value="100"></el-option>
        <el-option label="150 pcs" :value="150"></el-option>
        <el-option label="200 pcs" :value="200"></el-option>
        <el-option label="300 pcs" :value="300"></el-option>
      </el-select>
    </div>
    <table class="normal-table">
      <tr>
        <th v-for="col in itemsColumns" :key="col.key">{{ col.title }}</th>
      </tr>
      <tr v-for="item in itemsList" :key="item.id">
        <template v-for="col in itemsColumns">
          <td :key="col.key" v-if="col.key === 'part_no'"><el-button type="text" @click="partClick(item.product_id)">{{ item[col.key] }}</el-button></td>
          <td :key="col.key" v-else>{{ item[col.key] }}</td>
        </template>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      company: {
        id: this.$route.params.id,
        name: ''
      },
      itemsType: '0',
      itemsPageSize: 30,
      itemsList: [],
      itemsOfferColumns: [
        { key: 'oper_time', title: 'Input Time' },
        { key: 'company_name', title: 'Company' },
        { key: 'part_no', title: 'Part Number' },
        { key: 'description', title: 'Description' },
        { key: 'brand', title: 'Brand' },
        { key: 'display_c_qty', title: 'Qty' },
        { key: 'display_c_price', title: 'Price' },
        { key: 'c_remark', title: 'Remark' },
        { key: 'oper_name', title: 'EnterBy' }
      ],
      itemsRequireColumns: [
        { key: 'oper_time', title: 'Input Time' },
        { key: 'company_name', title: 'Company' },
        { key: 'part_no', title: 'Part Number' },
        { key: 'description', title: 'Description' },
        { key: 'brand', title: 'Brand' },
        { key: 'display_qty', title: 'Qty' },
        { key: 'display_price', title: 'Price' },
        { key: 'remark', title: 'Remark' },
        { key: 'oper_name', title: 'EnterBy' }
      ],
      itemsPOColumns: [
        { key: 'doc_date', title: 'Input Time' },
        { key: 'category_name', title: 'Category' },
        { key: 'class_name', title: 'Class' },
        { key: 'part_no', title: 'Part Number' },
        { key: 'description', title: 'Description' },
        { key: 'brand', title: 'Brand' },
        { key: 'qty', title: 'Qty' },
        { key: 'display_price', title: 'Price' },
        { key: 'sales_fullname', title: 'Sales' },
        { key: 'oper_fullname', title: 'Enter By' }
      ],
      itemsPIColumns: [
        { key: 'doc_date', title: 'Input Time' },
        { key: 'category_name', title: 'Category' },
        { key: 'class_name', title: 'Class' },
        { key: 'part_no', title: 'Part Number' },
        { key: 'description', title: 'Description' },
        { key: 'brand', title: 'Brand' },
        { key: 'qty', title: 'Qty' },
        { key: 'display_price', title: 'Price' },
        { key: 'sales_fullname', title: 'Sales' },
        { key: 'oper_fullname', title: 'Enter By' }
      ]
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    itemsColumns () {
      if (this.itemsType === '0') {
        return this.itemsOfferColumns
      } else if (this.itemsType === '1') {
        return this.itemsRequireColumns
      } else if (this.itemsType === '2') {
        return this.itemsPOColumns
      } else if (this.itemsType === '3') {
        return this.itemsPIColumns
      }
      return []
    }
  },
  watch: {
    itemsType (val) {
      this.fetchItemsList()
    }
  },
  mounted () {
    this.$store.dispatch('fetchSelect', 'category')
    this.$store.dispatch('fetchSelect', 'class')
    this.fetchCompany()
    this.fetchItemsList()
  },
  methods: {
    fetchCompany () {
      this.loading = true
      this.$http.get('/dbapi/company_list', {
        params: {
          id: this.$route.params.id
        }
      }).then(data => {
        this.loading = false
        if (data.list.length > 0) {
          this.company = data.list[0]
        }
      })
    },
    fetchItemsList () {
      let code = 'record_offer'
      if (this.itemsType === '1') {
        code = 'record_require'
      } else if (this.itemsType === '2') {
        code = 'po_list_time_desc'
      } else if (this.itemsType === '3') {
        code = 'invoice_list_time_desc'
      }
      this.$http.get('/dbapi/' + code, {
        params: {
          start: 0,
          limit: this.itemsPageSize,
          company_id: this.$route.params.id
        }
      }).then(data => {
        this.itemsList = data.list
      })
    },
    partClick (id) {
      if (this.itemsType === '0') {
        this.$open(`/product/${id}/offer`)
      } else if (this.itemsType === '1')  {
        this.$open(`/product/${id}/require`)
      } else if (this.itemsType === '2')  {
        this.$open(`/product/${id}/po`)
      } else if (this.itemsType === '3')  {
        this.$open(`/product/${id}/invoice`)
      }
    }
  }
}
</script>